import images from '../content/optimized-images.json';

// Prebuilt variants preserve the supplied artwork and work without a runtime image service.
export default function OptimizedImage({ src, crop, srcSet, sizes, width, height, loading, fetchPriority, decoding = 'async', ...props }) {
  const path = typeof src === 'string' ? src.split('?')[0] : src;
  const image = images[crop ? `${path}#${crop}` : path];
  return <img {...props}
    src={image?.src || src}
    srcSet={srcSet || image?.srcSet}
    sizes={sizes || (image ? image.sizes : undefined)}
    width={width || image?.width}
    height={height || image?.height}
    loading={loading || (fetchPriority === 'high' ? 'eager' : 'lazy')}
    fetchPriority={fetchPriority}
    decoding={decoding}
  />;
}
